module.exports = __webpack_public_path__ + "img/sDiamond7_193x205.2d747a36.png";